import { createPermissionsManager } from '@fusion/saas-components-v3'

export const permissions = createPermissionsManager()
